import { createModelPermissions } from 'components/permissions/utils/model-permission-generator';

const UserConst = createModelPermissions({
  modelName: 'users',
  basePath: '/users',
  permissions: {
    VIEW: true,
    UPDATE: true,
    DELETE: true,
    CHANGE_STATUS: true,
    CHANGE_PASSWORD: true,
  }
});

export default UserConst;